export { default } from './Slide';